import { createFileRoute } from '@tanstack/react-router'

import SubmissionLahanPage from '@/components/pages/backoffice/_klb-petani/_petani/_$petaniId/lahan/submission/containers/SubmissionLahanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/petani/$petaniId/lahan/submission/'
)({
  component: SubmissionLahanPage
})
